import { useContext, useEffect, useState } from 'react';

import { EventContext } from '../../Contexts/EventContext';
import Loading from '../../Shared/Components/Loading';
import { error, success } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import { baseApiUrl } from '../../Shared/utils/helper';
import Master from '../Layouts/Master';
import UserProfileForm from './UserProfileForm';

const Profile = () => {
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const eventContext = useContext(EventContext);
  const [loading, setLoading] = useState(true);
  const [countries, setCountries] = useState([]);
  const [photoIds, setPhotoIds] = useState([]);
  const [insuranceIds, setInsuranceIds] = useState([]);

  useEffect(() => {
    getInfo();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getInfo = async () => {
    setLoading(true);
    await useApi.get(
      '/user',
      {},
      (res) => {
        eventContext.user = res.data.data;
        eventContext.authUser = res.data.data;
        setLoading(false);
      },
      () => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
    await useApi.get(
      '/user/portal/provinces',
      {},
      (res) => {
        eventContext.provinces = res.data.data;
      },
      () => {
        error('هنگام دریافت استان‌ها خطایی رخ داده است.');
      },
    );
    await useApi.get(
      '/general/country',
      {},
      (res) => {
        setCountries(res.data.data || []);
      },
      () => {
        error('هنگام دریافت کشورها خطایی رخ داده است.');
      },
    );
  };

  const onSubmitForm = async (values) => {
    setSubmitFormLoading(true);

    if (photoIds.length > 0) {
      const photoId = photoIds[0].serverId;
      const thumbnail = JSON.parse(photoId);
      values.personnel_image = thumbnail.data.personnel_image;
    }

    if (insuranceIds.length > 0) {
      const insuranceId = insuranceIds[0].serverId;
      const uploaded = JSON.parse(insuranceId);
      values.insurance_image = uploaded.data.insurance_image;
    }

    if (!values.password) {
      delete values.password;
    }

    await useApi.put(
      '/panel/user',
      values,
      () => {
        success('اطلاعات با موفقیت ویرایش شد');
        setSubmitFormLoading(false);
        getInfo();
      },
      (err) => {
        const errors = err?.data?.errors;
        if (errors) {
          Object.values(errors).forEach((messages) => error(messages[0]));
        } else {
          error('خطایی در ثبت اطلاعات پیش آمده است.');
        }
        setSubmitFormLoading(false);
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master title='اطلاعات کاربری'>
      <UserProfileForm
        user={eventContext.user}
        provinces={eventContext.provinces}
        countries={countries}
        onSubmit={onSubmitForm}
        submitLoading={submitFormLoading}
        photoIds={photoIds}
        setPhotoIds={setPhotoIds}
        insuranceIds={insuranceIds}
        setInsuranceIds={setInsuranceIds}
        uploadProfileUrl={`${baseApiUrl()}/panel/user/upload/profile`}
        uploadInsuranceUrl={`${baseApiUrl()}/panel/user/upload/insurance`}
        showIncompleteWarning
      />
    </Master>
  );
};

export default Profile;
